import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";
import { Box, CardActions, CardContent, Divider, Grid, TableCell, tableCellClasses, Typography } from "@mui/material";
import ApexCharts from "react-apexcharts";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import planningImg from "../../../../assets/images/home/planning.svg";
import bannerBg from "../../../../assets/images/home/home-banner-bg.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/images/conpetency-arrow-right.svg";
import { Link as RouterLink, useNavigate } from "react-router-dom";

styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left': 0,
    },
}));
const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(186, 217, 87,0.15)",
        padding: "5px 12px",
        color: "#93AC41",
        // opacity: "0.15",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    }
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
});

function BarLegend(props) {
    const { data, colors } = props
    // const data = props.data;
    let row = [];
    const { t } = useTranslation()
    let percent = (data) => {
        let sumpercent = 0
        if (data > 0) {
            sumpercent = ((data / props.totalScore) * 100)
        }
        return sumpercent.toFixed(2)
    }
    for (var i = 0; i < data?.series.length; i++) {
        row.push(
            <Box key={data.series[i].id} display="flex" alignItems="center" pt={1}>
                <Box sx={{ width: "10%" }} mr="2.5">
                    <div className="bar-legend-square" style={{ backgroundColor: colors[i] }}></div>
                </Box>
                <Box sx={{ width: "70%", overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis" }} px="2.5px"><Typography fontSize={16} lineHeight="24px" fontWeight={400} style={styles.barLegend} sx={{ color: "#A3A3A3 !important" }}> {t(`label.${data.options.labels[i]}`)}</Typography></Box>
                <Box sx={{ width: "20%", textAlign: "right" }} px="2.5px"><Typography fontSize={16} lineHeight="24px" style={styles.barLegend} fontWeight={500} color="#939393"> {data.series[i]}</Typography></Box>
            </Box>
        );
    }
    return (row)
}

export default function TotalAchievements(props) {
    const { t } = useTranslation();
    const { datas, dataPA, emp_id, cycle } = props;
    const classes = useStyles();
    const navigate = useNavigate();
    const [dataSeries, setDataSeries] = React.useState([]);
    const [dataLabel, setdataLabel] = React.useState([]);
    const [criterionScore, setCriterionScore] = React.useState([0]);
    const [colorBar, setColor] = React.useState(["#FA9349", "#74C1ED", "#F7B254", "#31B09B"]);
    const [dataBarChart, setDataBarChart] = React.useState([]);
    const [loadApex, setLoadApex] = React.useState(true);
    useEffect(() => {
        mapping()
    }, [datas]);
    // let sumScore = (data) => {
    //     let totals = 0
    //     data.rb_condition.map((data) => { totals = totals + calculateScore(data) })
    //     return totals
    // }
    // let totalScore = () => {
    //     let totals = 0
    //     if (typeList.length > 0) {
    //         typeList.map((data) => { totals = totals + Number(data?.data[0]) })
    //     }
    //     return totals.toFixed(2)
    // }
    // let calculateScore = (data) => {
    //     let sum = eval(data.calculate_score)
    //     let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
    //     return scores
    // }
    // let sumScoreAccumulateUse = (data) => {
    //     let totals = data?.accumulate_use !== undefined && data?.accumulate_use !== null && data?.accumulate_use !== "" ? Number.isNaN(Number(data?.accumulate_use)) ? 0 : Math.round(data?.accumulate_use * 100) / 100 : 0
    //     for (let index = 0; index <= data.rb_condition.length - 1; index++) {
    //         totals = totals + Number(calculateScore(data.rb_condition[index]))
    //     }
    //     return Number.isNaN(Number(totals)) ? 0 : Number(totals).toFixed(2)
    // }
    const mapping = () => {
        if (datas !== undefined && datas !== null && datas !== "null") {
            setDataSeries(datas?.chart?.series)
            setdataLabel(datas?.chart?.labels)
        }
    }
    let chartOptions = {
        type: "donut",
        series: dataSeries,
        options: {
            unit: "คะแนน",
            chart: {
                type: "donut",
                height: "140px",
            },
            colors: ['#F0F0F0',
                // cssVariables.barChart.totalAchievements["100"],
                // cssVariables.barChart.totalAchievements["200"],
                // cssVariables.barChart.totalAchievements["300"],
                // cssVariables.barChart.totalAchievements["400"],
            ],
            labels: dataLabel,
            states: {
                hover: {
                    filter: {
                        type: 'darken',
                        value: 0.9,
                    }
                },
            },
            plotOptions: {
                pie: {
                    startAngle: 0,
                    endAngle: 360,
                    expandOnClick: true,
                    offsetX: 0,
                    offsetY: 0,
                    customScale: 1,
                    dataLabels: {
                        offset: 0,
                        minAngleToShowLabel: 10,
                    },
                    donut: {
                        size: '70%',
                        background: 'transparent',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '12px',
                                fontFamily: "Kanit",
                                fontWeight: 300,
                                color: '#6B6B6B',
                                offsetY: 25,
                                formatter: () => t('label.total')
                            },
                            value: {
                                show: true,
                                fontSize: '30px',
                                fontFamily: "Kanit",
                                fontWeight: 500,
                                color: "#5DA196",
                                offsetY: -15,
                                formatter: function (val) {
                                    return val
                                }
                            },
                            total: {
                                show: true,
                                showAlways: true,
                                fontSize: '16px',
                                fontFamily: "Kanit",
                                fontWeight: 300,
                                color: '#A3A3A3',
                                background: "#fff",
                                formatter: function (w) {
                                    return w.globals.seriesTotals.reduce((a, b) => {
                                        return a + b
                                    }, 0)
                                }
                            }
                        },
                    },
                }
            },
            stroke: {
                width: 0,
                colors: ["#fff"],
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: true,
                enabledOnSeries: undefined,
                shared: true,
                followCursor: false,
                intersect: false,
                inverseOrder: false,
                custom: undefined,
                fillSeriesColor: false,
                theme: false,
                onDatasetHover: {
                    highlightDataSeries: false,
                },
                style: {
                    fontSize: '14px',
                    fontFamily: "Kanit",
                    fontWeight: 300,
                },
                x: {
                    show: true,
                },
                y: {
                    title: {
                        formatter: (seriesName) => seriesName + ":",
                    },
                    style: {
                        fontSize: '14px',
                        fontFamily: "Kanit",
                        fontWeight: 300,
                    },
                    formatter: function (val) {
                        return val;
                    },
                },
                marker: {
                    show: true,
                },
                items: {
                    display: "flex",
                },
                fixed: {
                    enabled: false,
                    position: 'topRight',
                    offsetX: 0,
                    offsetY: 0,
                },
            },
            fill: {
                opacity: 1,
                // type: ['solid', 'gradient'],
                // colors: '#000'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 140
                    },
                    legend: {
                        show: false
                    }
                }
            }],
            legend: {
                show: false,
                position: "right",
                offsetY: 0,
                height: 200,
                // horizontalAlign: "left",
                // offsetX: -33,
                // offsetY: -55,
                formatter: function (val, opts) {
                    const roundToHundred = (arr) => {
                        let output = [];
                        let acc = 0;
                        for (let i = 0; i < arr.length; i++) {
                            let roundedCur = Math.round(arr[i][0]);
                            const currentAcc = acc;
                            if (acc == 0) {
                                output.push(roundedCur);
                                acc += arr[i][0];
                                continue;
                            }
                            acc += arr[i][0];
                            output.push(Math.round(acc) - Math.round(currentAcc));
                        }
                        return output;
                    };
                    let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
                    return (
                        "<span class='fs-12px ml-2'>" +
                        (val ? val : "-") +
                        ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
                        (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                        " (" + (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) + "%)" +
                        "</span>"
                    );
                },
            },
        },
    };
    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    return (
        <Box px={2} py={1} height="100%">
            <CardContent className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "10px 0 !important", height: "100%" }}>
                {/* <Box>
                      <img src={fileBrowser} alt="browser" />
                    </Box>
                    <Box>
                      <Typography>{t("home.label.nodata")}</Typography>
                    </Box> */}
                <Grid container pb={2}>
                    <Grid item lg={12} xs={10} display="flex" justifyContent="space-between" alignItems="center">
                        <Typography fontSize={20} lineHeight="22px" fontWeight={600} color="#404349" sx={{ textAlign: "left" }}>
                            {t('evaluation.totalAchievements')}
                        </Typography>
                        <Box sx={{ display: "flex", "flex-direction": "row", "align-items": "center", cursor: "pointer" }}>
                            <Typography onClick={e => openNewTab(`/kpi/achievement?emp_id=${emp_id}&cycle=${cycle}`)} fontSize={14} fontWeight="400" color="primary" sx={{ textDecoration: "underline", transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", '&:hover': { color: 'rgb(65, 112, 105) !important' } }}>
                                {t('label.viewAll')} <ArrowRight style={{ "margin-left": "8px" }} />
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Box display="flex" alignItems="center" width="100%" height="100%" justifyContent="space-around" >
                    <Box sx={{ ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                        <ApexCharts
                            // style={{ width: "140px", height: "140px" }}
                            options={{ ...chartOptions.options, colors: colorBar }}
                            series={chartOptions.series}
                            type={chartOptions.type}
                            responsive={chartOptions.responsive}
                            labels={chartOptions.labels}
                            // maxHeight="100%"
                            // maxWidth="100%"
                            height={160}
                            width={140}
                        ></ApexCharts>
                    </Box>
                    <Box sx={{ width: "calc(100% - 140px)", paddingLeft: "20px", maxWidth: "240px" }}>
                        <Box sx={{ width: "calc(100% + 0px)" }}>
                            <Box item lg={12} xs={12}>
                                <BarLegend data={chartOptions} colors={colorBar}></BarLegend>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </CardContent>
        </Box >
    )
}

